import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import Vue from 'vue'
import {getSheetConfig} from '@/apis/sheetConfig'
import {isAdmin, searchView} from '@/apis/sheet'
import {AppModule} from './app'
export interface ISheetState {
    sheetFieldList: any[]
    sheetFieldMap: any
    worksheetId: string
    applicationId: number | undefined
    viewAuthority: {canEdit?: boolean, canDelete?: boolean, canRead?: boolean}
    worksheetAuthority: {canAdd?: boolean, deleteType?: number, editType?: number, readType?: number}
}

@Module({ dynamic: true, store, name: 'sheet' })
class Sheet extends VuexModule implements ISheetState {
  public worksheetId = ''
  public titleField = ''
  public applicationId = undefined
  public isAdmin =  false
  public pendding = false // 编辑记录 回显时为true
  public currViewSheetId = ''
  public worksheetInfo = {
    name: '',
    icon: '',
    description: ''
  }
  public hideRowMap = {}
  public expandConfig = {
    createSaveButtonName: '',
    updateSaveButtonName: ''
  }
  public worksheetAuthority = {}
  public sheetFieldList: any = [

  ]
  public sheetFieldMap: any = {

  }
  public allSheetMap: any = {
    
  }
  public currentView: any = {}
  public get viewAuthority () {
    if (this.isAdmin) {
      return {canRead: true, canEdit: true, canDelete: true}
    } else {
      let {viewAuthority = {}} = this.currentView
      return viewAuthority || {}
    }
  }
  @Action
  public async getSheetConfig (data) {
    const res = await getSheetConfig(data)
    if (res.success) {
      this.SET_SHEET_FIELDLIST(res.data)
      return res.data
    }
    return  Promise.reject()
  }
  @Action
  public async getIsAdmin (data) {
    const res = await isAdmin(data)
    if (res.success) {
      this.UPDATE_IS_ADMIN(res.data)
      return res
    }
  }
  @Action
  public async getsViewHideRow (viewId) {
    if (this.hideRowMap[viewId]) {
      return
    }
    const res = await searchView(viewId)
    if (res.success) {
      this.CACHE_VIEW_HIDEROW({viewId, hideRow: res.data.hideRow})
    }
  }
  @Mutation
  public CACHE_VIEW_HIDEROW ({viewId, hideRow}) {
    Vue.set(this.hideRowMap, viewId, hideRow)
  }
  @Mutation
  public UPDATE_VIEW (payload) {
    Vue.set(this, 'currentView', Object.assign({}, payload))
  }
  @Mutation
  public CHANGE_PENDDING (payload) {
    this.pendding = payload
  }
  @Mutation
  public CHANGE_CURRVIEWSHEETID (payload) {
    this.currViewSheetId = payload
  }
  @Mutation
  public UPDATE_IS_ADMIN (payload) {
    this.isAdmin = payload
  }
  @Mutation
  public UPDATE_WORKSHEETINFO (payload) {
    this.worksheetInfo = payload
  }
  @Mutation
  public SET_SHEET_FIELDLIST(payload) {
    if (AppModule.containerType === 'cep') {
      this.sheetFieldList = (payload.fields || []).filter((item) => {
        return item.fieldType !== 'associationTable'
      })
    } else {
      this.sheetFieldList = (payload.fields || [])
    }
    this.sheetFieldList = (payload.fields || [])
    this.sheetFieldMap = {}
    this.expandConfig = payload.expandConfig
    this.titleField = payload.titleField
    this.isAdmin = payload.isAdmin
    if (payload.isAdmin) {
      this.worksheetAuthority = {
        canAdd: true, deleteType: 100, editType: 100, readType: 100
      }
    } else {
      this.worksheetAuthority = payload.worksheetAuthority || {}
    }
    this.sheetFieldList.map((item) => {
      this.sheetFieldMap[item.businessId] = item
    })
  }

}

export const SheetModule = getModule(Sheet)
